import { render, staticRenderFns } from "./CustomerPortalHome.vue?vue&type=template&id=5e8bbf61&scoped=true&"
import script from "./CustomerPortalHome.vue?vue&type=script&lang=js&"
export * from "./CustomerPortalHome.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e8bbf61",
  null
  
)

export default component.exports